import * as React from 'react';
import {useEffect, useRef} from 'react';
import {Container, Image} from "react-bootstrap";
import Section from './Section';
import {Element} from "react-scroll";
import {Footer} from "./Footer";
import ComplaintForm from "./ComplaintForm";

export function Main({setOpacity}) {
    const scrollRef = useRef(null);
    const scrollData = useRef({
        lastScrollY: 0,
        pointOfFade: 0
    })

    useEffect(() => {
        const el = scrollRef.current;
        const handleScroll = () => {
            const currentScrollY = el.scrollTop;
            const scrollDirection = currentScrollY > scrollData.current.lastScrollY ? 1 : -1
            const maxFade = 100; // distance over which it fades
            const offSet = scrollDirection * (50);
            const newOpacity = currentScrollY < scrollData.current.lastScrollY ?
                0.5 :
                0.9 - (currentScrollY - scrollData.current.pointOfFade) / maxFade;
            setOpacity(Math.max(0, Math.min(1, currentScrollY < 50 ? 0.9 - currentScrollY / maxFade : newOpacity)));
            if (currentScrollY < scrollData.current.lastScrollY) {
                scrollData.current.pointOfFade = currentScrollY + offSet
            }
            scrollData.current.lastScrollY = currentScrollY
        };

        el.addEventListener("scroll", handleScroll);
        return () => el.removeEventListener("scroll", handleScroll);
    }, []);


    return (
        <main id="main"
              className="main-container overflow-auto d-flex flex-column justify-content-start align-items-center"
              ref={scrollRef}>
            <Element name="home"/>
            <Image
                className="main-image"
                src="/assets/espresso-surrounded-by-scattered-coffee-beans-dark-surface.jpg"
            />
            <Image
                className="main-logo"
                src="/assets/EccoPresso_logo_pod_start_edited_edited.png"
            />
            <Element name="about"/>
            <Container className="d-flex flex-row align-items-center mt-5">
                <Image
                    className="who-are-we-image me-lg-5"
                    src="/assets/EP_keretes.png"
                />
                <div className="who-are-we-container ps-5">
                    <h4 className="mb-5">Kik vagyunk?</h4>
                    <p className="mb-0">Mi vagyunk az EccoPresso, csapatunk célja az E.S.E. rendszerű kávégépek
                        népszerűsítése.
                    </p>
                    <p>Ez egy kiemelten Olaszországban elterjedt technológia, mely környezetbarát alternatívát nyújt a
                        kapszulás gépekkel szemben.
                    </p>
                </div>
            </Container>
            <Element name="pro"/>
            <h5 className="title choose-us">Miért minket <br/>válassz?</h5>
            <Section
                src="/assets/EP_brass_coffee_machine.png"
                title="Egyszerűség"
                subtitle="Egy mozdulat, és kész a friss eszpresszó."
                paragraphs={[
                    "Nem kell adagolni, mérni, tisztítani. A nagy gépekkel ellentétben a mi megoldásaink nem igényelnek professzionális karbantartást, így extra költséget sem generálnak.",
                    "A piacon lévő kapszulás megoldásokkal szemben akár nagy víztartállyal is tudjuk szállítani őket, vagy választhatók kifejezetten vendéglátóipari igénybevételre tervezett típusok is.",
                    "Ezek a tulajdonságok jelentős előnyt nyújtanak a hagyományos kapszulás gépekkel szemben."
                ]}
            />
            <Section
                src="/assets/cup-espresso-coffee-pod_edited.png"
                title="Gazdaságosság"
                subtitle="Versenyképes árainknak köszönhetően prémium élményt nyújthatsz megfizethető áron."
                paragraphs={[
                    "Kávépárnáink (pod) nem a kompakt megoldásoknál megszokott 5 g, hanem 40%-kal több, azaz 7 g kávét tartalmaznak, ennek ellenére árban is legtöbbször a gazdaságosabb választás a pod."
                ]}
                reversed
            />
            <Section
                src="/assets/EP_keretes_harvest.png"
                title="Fenntarthatóság"
                subtitle="A podok 100%-ban lebomló papírfilterből készülnek."
                paragraphs={[
                    "Semmilyen műanyagot nem tartalmaznak, a szállításhoz szükséges csomagolás kivételével.",
                    "A pod közvetlenül a komposztba is dobható! Lefőzés után mehet a szemetesbe vagy a komposztba – környezetbarát és egyszerű."
                ]}
            />
            <Section
                src="/assets/didiesse_frog.png"
                title="Rugalmas belépés"
                subtitle="Kávépodok mellé ingyen kávéfőző gépet is szolgáltatunk új partnereinknek!"
                paragraphs={[
                    "Hűséges partnereink számára akár prémium minőségű gépeket is tudunk biztosítani."
                ]}
                reversed
            />
            <Section
                src="/assets/EP_keretes_coffees.png"
                title="Színes termékpaletta"
                subtitle="Különböző ízvilágok széles választéka vár nálunk."
                paragraphs={[
                    "Folyamatosan bővülő kínálatunkban a pénztárcabarát megoldásoktól a prémium minőségig mindent megtalálsz.\n" +
                    "Magyar és külföldi pörkölőkkel együttműködve nagy varianciát biztosítunk egy rendelésen belül – ízben és árban egyaránt."
                ]}
            />

            <Element name="how"/>
            <h5 className="title">Hogy néz ki használat közben?</h5>
            <p className="paragraph">
                A videó egy Didiesse Frog kávégépet mutat be.<br/>
                A gép egy példa, számos más géppel dolgozunk az apróktól a robosztusokig egyaránt. <br/>
                Nincs szükség betanításra.
            </p>
            <div className="d-flex flex-column justify-content-start align-items-center">
                <Image
                    className="w-100 z-0"
                    src="/assets/coffe_beans_background.jpg"
                />
                <iframe
                    className="yt-widget1"
                    src="https://www.youtube.com/embed/bLSzdJ7xbTw"
                    title="Frog | Tutorial pod coffee machine"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                />
                <Image
                    className="coffe-beans-foreground"
                    src="/assets/mockup-coffee-beans-isolated-white-backg.png"
                />
            </div>
            <h5 className="title">Az elkészítés gyerekjáték</h5>
            <Image src="/assets/coffee-machine-info-graphics.png"/>
            <div className="d-flex flex-row justify-content-between gap-5">
                <p className="instruction">Beteszed a podot</p>
                <p className="instruction">Lehúzod a kart</p>
                <p className="instruction">Benyomod a gombot</p>
                <p className="instruction">Kiveszed a podot</p>
                <p className="instruction">Komposztálóba dobod a podot</p>
            </div>
            <div className="next-step-container">
                <h5 className="my-5">Következő lépés?</h5>
                <div className="d-flex flex-row justify-content-center gap-5">
                    <p>
                        Mivel nincs két egyforma cég és igény, ajánlatainkat személyre szabjuk. <br/>
                        Ha érdekes számodra az együttműködés, vedd fel velünk a kapcsolatot, hogy megismerhessük
                        elképzeléseidet és testreszabott ajánlatot adhassunk.
                    </p>
                    <ul className="d-flex flex-column justify-content-start gap-4">
                        <li className="">Segítünk kiválasztani a számodra legmegfelelőbb megoldást</li>
                        <li className="">Igény esetén kiegészítőkkel is ellátunk (pl. poharak, cukor, stb...)</li>
                        <li className="">Támogatjuk a beszerzést, hogy minél egyszerűbb dolgod legyen</li>
                    </ul>
                </div>
            </div>
            <div className="d-flex flex-column justify-content-start align-items-center gap-5">
                <Image className="about-us-background" src="/assets/contacts_bg.jpg"/>
                <div className="about-us-content d-flex flex-column justify-content-start align-items-center px-5">
                    <h5 className="title mb-5">Rólunk mondták</h5>
                    <p>“DOUBLE CLICK HERE OR CLICK EDIT TEXT TO ADD SOME POSITIVE FEEDBACK ABOUT YOUR SERVICES"</p>
                    <span>NAME / JOB / TITLE</span>
                    <p>“DOUBLE CLICK HERE OR CLICK EDIT TEXT TO ADD SOME POSITIVE FEEDBACK ABOUT YOUR SERVICES"</p>
                    <span>NAME / JOB / TITLE</span>
                </div>
            </div>
            <Element name="contacts"/>
            <div className="contacts-container d-flex flex-column justify-content-start align-items-center gap-3 py-5">
                <h5 className="title">Kapcsolat</h5>
                <p className="paragraph">
                    További információért, rendelésért vagy egyedi ajánlatért keressen minket bizalommal:
                </p>
                <div className="d-flex flex-row justify-content-center gap-5">
                    <div className="d-flex flex-column justify-content-start align-items-center gap-0">
                        <p className="contacts-subtitle">Weboldal</p>
                        <a className="paragraph">www.eccopresso.com</a>
                    </div>
                    <div className="d-flex flex-column justify-content-start align-items-center gap-0">
                        <p className="contacts-subtitle">Telefon</p>
                        <p className="paragraph">+36 20 482 4335</p>
                    </div>
                    <div className="d-flex flex-column justify-content-start align-items-center gap-0">
                        <p className="contacts-subtitle">E-mail</p>
                        <p className="paragraph">info@eccopresso.com</p>
                    </div>
                </div>
                <h6>Írj nekünk!</h6>
                <ComplaintForm/>
            </div>
            <Footer/>

        </main>
    );
}